/* Sales choose the homepage families; only a confirmed catalogue ID selects fitment. */
(function () {
  'use strict';
  function setup(root) {
    if (root.dataset.modelsReady) return;
    root.dataset.modelsReady = '1';
    const dialog = root.querySelector('dialog'), search = root.querySelector('[data-family-search]');
    const list = root.querySelector('[data-family-options]'), status = root.querySelector('[data-family-status]');
    const request = root.querySelector('[data-family-request]');
    let opener, vehicles = [], generation = 0;
    function render() {
      const query = search.value.trim();
      const matches = window.EsvSearchPicker?.matches || ((label, text) => label.toLocaleLowerCase('de').includes(text.toLocaleLowerCase('de')));
      const found = vehicles.filter(vehicle => matches(vehicle.label, query));
      list.replaceChildren();
      for (const vehicle of found) {
        const item = document.createElement('li'), link = document.createElement('a');
        link.textContent = vehicle.label;
        link.href = window.EsvPartsVehicle.url(opener.href, vehicle.id);
        link.dataset.familyVehicle = vehicle.id;
        item.append(link); list.append(item);
      }
      status.textContent = found.length ? `${found.length} ${found.length === 1 ? 'Modell' : 'Modelle'} zur Auswahl` : 'Kein Modell gefunden. Prüfe die Schreibweise oder stelle eine Anfrage.';
      const url = new URL(opener.href);
      url.searchParams.set('esv_inquiry', '1');
      url.searchParams.set('esv_inquiry_vehicle', [opener.dataset.familyBrand, opener.dataset.familyLabel, query].filter(Boolean).join(' ').slice(0, 200));
      request.href = url.href;
    }
    root.querySelectorAll('[data-model-entry]').forEach(link => link.addEventListener('click', async event => {
      if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !window.EsvPartsVehicle || !dialog.showModal) return;
      event.preventDefault();
      opener = link; const current = ++generation;
      vehicles = []; list.replaceChildren(); search.value = ''; search.disabled = true;
      root.querySelector('[data-family-title]').textContent = `${link.dataset.familyLabel}: Genaues Modell auswählen`;
      request.href = link.href + '&esv_inquiry=1';
      status.textContent = 'Modelle werden geladen …';
      dialog.showModal(); root.querySelector('[data-family-close]').focus();
      try {
        const data = await window.EsvPartsVehicle.load();
        if (current !== generation || !dialog.open) return;
        vehicles = window.EsvShopifyCatalog.family(data.vehicles, link.dataset.familyBrand, link.dataset.familyLabel);
        if (!vehicles.length) throw new Error('Family catalogue changed');
        search.disabled = false; render(); search.focus();
      } catch (_) {
        if (current !== generation || !dialog.open) return;
        vehicles = []; list.replaceChildren();
        status.textContent = 'Die Modellauswahl konnte nicht geladen werden. Nutze die vollständige Auswahl oder stelle eine Anfrage.';
      }
    }));
    search.addEventListener('input', render);
    root.querySelector('[data-family-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { generation++; opener?.focus(); });
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
    list.addEventListener('click', event => {
      const link = event.target.closest('[data-family-vehicle]');
      if (link && event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && vehicles.some(v => v.id === link.dataset.familyVehicle)) {
        window.EsvPartsVehicle.set(link.dataset.familyVehicle, 'homepage-family');
      }
    });
  }
  document.querySelectorAll('[data-model-families]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-model-families]').forEach(setup));
})();
